import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface LargeTextProps
  extends HTMLAttributes<HTMLParagraphElement>,
    CommonComponentProps {}

export function LargeText({ children, className, ...rest }: LargeTextProps) {
  return (
    <b
      className={cx(
        "font-sans text-base font-semibold leading-normal text-foreground",
        className
      )}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </b>
  );
}
